// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getAllEventsRequest: ['data'],
  getAllEventsSuccess: ['data'],
  getAllEventsFailure: ['err'],

  getEventsRequest: ['data'],
  getEventsSuccess: ['data'],
  getEventsFailure: ['err'],

  getEventsCategoriesRequest: ['data'],
  getEventsCategoriesSuccess: ['data'],
  getEventsCategoriesFailure: ['err'],

  getAllPopularEventsRequest: ['data'],
  getAllPopularEventsSuccess: ['data'],
  getAllPopularEventsFailure: ['err'],

  setPopularEventRequest: ['data'],
  setPopularEventSuccess: ['data'],
  setPopularEventFailure: ['err'],

  resetEventDescriptionRequest: ['data'],
  resetEventDescriptionSuccess: ['data'],
  resetEventDescriptionFailure: ['err'],

  updateEventDescriptionRequest: ['data'],
  updateEventDescriptionSuccess: ['data'],
  updateEventDescriptionFailure: ['err']
})

export const EventsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  data_category: [],
  data_popular: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, err: null, success: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const successCategory = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_category: data,
    err: null
  })

export const successPopular = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data_popular: data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const failureCategory = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err, data_category: [] })

export const failurePopular = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err, data_popular: [] })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ALL_EVENTS_SUCCESS]: success,
  [Types.GET_ALL_EVENTS_REQUEST]: request,
  [Types.GET_ALL_EVENTS_FAILURE]: failure,

  [Types.GET_EVENTS_SUCCESS]: success,
  [Types.GET_EVENTS_REQUEST]: request,
  [Types.GET_EVENTS_FAILURE]: failure,

  [Types.GET_EVENTS_CATEGORIES_SUCCESS]: successCategory,
  [Types.GET_EVENTS_CATEGORIES_REQUEST]: request,
  [Types.GET_EVENTS_CATEGORIES_FAILURE]: failureCategory,

  [Types.GET_ALL_POPULAR_EVENTS_SUCCESS]: successPopular,
  [Types.GET_ALL_POPULAR_EVENTS_REQUEST]: request,
  [Types.GET_ALL_POPULAR_EVENTS_FAILURE]: failurePopular,

  [Types.SET_POPULAR_EVENT_SUCCESS]: manipulateSuccess,
  [Types.SET_POPULAR_EVENT_REQUEST]: manipulateRequest,
  [Types.SET_POPULAR_EVENT_FAILURE]: manipulateFailure,

  [Types.RESET_EVENT_DESCRIPTION_SUCCESS]: success,
  [Types.RESET_EVENT_DESCRIPTION_REQUEST]: request,
  [Types.RESET_EVENT_DESCRIPTION_FAILURE]: failure,

  [Types.UPDATE_EVENT_DESCRIPTION_SUCCESS]: success,
  [Types.UPDATE_EVENT_DESCRIPTION_REQUEST]: request,
  [Types.UPDATE_EVENT_DESCRIPTION_FAILURE]: failure
})



// WEBPACK FOOTER //
// ./src/Redux/EventsRedux.js